import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getDeveloperRequests } from "store/actions";

import Table from "./Table";

const AdvirtiseType = () => {
  const dispatch = useDispatch();
  const { developerRequests, loading } = useSelector(
    (state) => state.developerRequests
  );

  useEffect(() => {
    dispatch(getDeveloperRequests());
  }, [dispatch]);

  return (
    <div className="property-wrap">
      <Table data={developerRequests} loading={loading} />
    </div>
  );
};

export default AdvirtiseType;
